import { Service } from '@/request/http.js'

// 优惠券列表
export function myCoupon (data) {
  return Service({
    url: '/api/myCoupon',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/request/coupon.js